module.exports = __webpack_public_path__ + "img/engman-otzS.83cd6be3.svg";